module.exports = __webpack_public_path__ + "img/cxample_04.fb4ef6e4.png";